export const NAME_KEY = "name";
export const LOCALE_FOR_PRICE = "nl-NL";
export const KIND_KEY = "type";
export const PRICE_KEY = "price";
export const SHOW_KEY = "show";
export const FULL_CATEGORY_KEY = "menu_category";
export const DIETARY_PREFERENCES_KEY = "dietaryPreferences";

export const KINDS = {
  CATEGORY: "category-name",
  PRODUCT: "product",
  META: "meta",
};
